import React, { useState } from 'react';
import { getFormData } from '../../../helpers/formHelper';
import ThankYouModal from '../ThankYouModal';
import LoadingSpinner from '../../LoadingSpinner';
import Modal from '../../Modal/Modal';
import propTypes from './propTypes';
import ErrorList from '../../Errors/ErrorList';
import { pleaseAddCommentText } from "../../../constants/errorMessages";
import { getErrors } from "../../../helpers/errorHelper";

function ReplyModal(props) {
  const [replyText, setReplyText] = useState('');
  const {
    maxChars,
    pendingCommentSubmission,
    pendingCommentSubmissionState,
    setPendingCommentSubmissionState,
    parentId,
    handleCloseButtonClick,
    errors,
    closeRootModal,
    resetSkipAndTop,
    dismissError,
    createContribution,
    setReloadComments
  } = props;

  // If there is an error we want to add a border around the offending element
  let errorList = {};
  if (props.pendingCommentSubmissionState === 'fail' && errors) {
    errorList = getErrors(errors);
  }

  function handleUserInput(input) {
    const inputValue = input.length < maxChars ? input : input.substring(0, maxChars);
    setReplyText(inputValue);
  }

  function submitHandler(e) {
    e.preventDefault();
    dismissError();
    // Store all of the named fields in a formData object
    const formData = getFormData(e.target);
    createContribution(formData);
  }

  function handleThankYouClick() {
    setPendingCommentSubmissionState('');
    closeRootModal();
    resetSkipAndTop();
    setReloadComments(true);
  }

  return (
    <>
      {
        pendingCommentSubmissionState !== 'success' &&
        <form className="ugc-contribution-modal ugc-contribution-modal-reply-container"
              onSubmit={submitHandler}>
            <h2 className="h3 ugc-contribution-modal-reply-container-title">
            Reply to comment
          </h2>

          {
            pendingCommentSubmissionState === 'fail' && errors &&
            <ErrorList errors={errors}/>
          }

          <input type="hidden"
                 name="ParentId"
                 value={parentId}/>
            <div className="form-group ugc-contribution-modal-reply-input-container">
            <label className="sr-only"
                   htmlFor="replyField">
              Reply
            </label>

            {
              errorList.hasCommentError &&
                <div className="ugc-contribution-modal--reply-comments-field-error">
                {pleaseAddCommentText}
              </div>
            }

            <textarea id="replyField"
                className={`form-control ugc-contribution-modal--textarea ${errorList.hasCommentError ? 'border-error ugc-contribution-modal--textarea-error' : 'ugc-contribution-modal--textarea-default'}`}
                      placeholder="Enter your reply..."
                      rows="5"
                      name="Text"
                      value={replyText}
                      onChange={(e) => handleUserInput(e.target.value)}/>
            <div id="comments-character-count"
                className="ugc-contribution-modal--alias-character-count">
              {maxChars - replyText.length} characters left
            </div>
          </div>

            <div className="modal__buttons-wrapper ugc-contribution-modal--submit-button">
              <button className="govuk-button he-button he-button__primary">
              Submit reply
            </button>
              <button className="govuk-button he-button he-button__secondary"
                    onClick={(e) => {
                      handleCloseButtonClick(false, closeRootModal, dismissError, e);
                    }}>
              Cancel
            </button>

            {
              pendingCommentSubmission &&
              <LoadingSpinner/>
            }

          </div>
        </form>
      }

      {
        pendingCommentSubmissionState === 'success' &&
        <Modal
          closeRootModal={handleThankYouClick}
          isSmallModal={true}>
          <ThankYouModal closeRootModal={handleThankYouClick}/>
        </Modal>
      }

    </>
  );
}

ReplyModal.propTypes = propTypes;
export default ReplyModal;
